/**
 * `DA.1` (`oq-ММБ-188`): ток станции на экране.
 *
 * `current_dA` — десятые доли (93 → «9,3»); `current_dA === null` — десятых нет,
 * показываем целые (`currentA`, 9 → «9»), без мнимой «,0».
 */
export function formatCurrentValue(
  currentA: number | string | null | undefined,
  currentDA: number | string | null | undefined,
): string | null {
  if (currentDA !== null && currentDA !== undefined && currentDA !== "") {
    const deca = Number(currentDA);

    if (Number.isFinite(deca)) {
      return (deca / 10).toFixed(1).replace(".", ",");
    }
  }

  if (currentA === null || currentA === undefined || currentA === "") {
    return null;
  }

  const amperes = Number(currentA);

  return Number.isFinite(amperes) ? String(amperes) : null;
}
